import {Backbone} from 'Vertebrae';
import {ConferenceNumber} from '../model/conferenceNumber';

export const ConferenceNumbers = Backbone.Collection.extend({
    _name: 'ConferenceNumbers',
    model: ConferenceNumber,
    url: '/conferenceNumbers/get.json',
});
